/* eslint-disable */
import React, { useState } from 'react';
import '../../components/buttons/mainBtn.css';
import './startPage.css';
import { Trans, useTranslation } from 'react-i18next';
import { Row } from 'react-bootstrap';
import Modal from '../../components/modal/Modal';
import { Link } from 'react-router-dom';
import { Button, ActionButtonSpinner, getActionButtonLoadingClassName } from '@ui';

export default function DelayedStartModal({
  stationNumber,
  setError,
  kwt,
  openFrom,
  openPaymentLink,
  modalOpen,
  setModalOpen,
  autoStart,
}) {
  const { t } = useTranslation();
  const [isPaying, setIsPaying] = useState(false);

  async function handlePay() {
    if (isPaying) return;
    setIsPaying(true);
    await openPaymentLink(stationNumber, kwt, autoStart, setError);
    setIsPaying(false);
  }

  return (
    <Modal modalOpen={modalOpen} setModalOpen={setModalOpen}>
      <h1 className="delayedStartWarning">
        <Trans i18nKey="delayedStart">Charging will begin at {{ openFrom }}</Trans>
      </h1>
      <Button
        className={`mainBtn buttonForOfflineStation w-100 mb-1 mt-4 ${getActionButtonLoadingClassName(isPaying)}`}
        disabled={isPaying}
        aria-busy={isPaying}
        onClick={handlePay}
      >
        {isPaying ? <ActionButtonSpinner /> : <span className="mainBtnText">{t('btnPay')}</span>}
      </Button>
      <Row as={Link} to={`/?station=${stationNumber}`} className="mainBtn mb-1 mt-4">
        <p className="mainBtnText ">{t('btns.getNearestStationsStatus')}</p>
      </Row>
    </Modal>
  );
}
